import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';

const { getUsername, isBrand } = require('../../Helpers/user_helpers');

const RootRedirect = props => {
  const { loggedInUsername, isBrand } = props;
  return <Redirect to={{ pathname: loggedInUsername ? (isBrand ? `/talent` : `/links`) : '/home' }} />;
};

const mapStateToProps = state => {
  const { user } = state;
  return {
    loggedInUsername: getUsername(user),
    isBrand: isBrand(user)
  };
};

export default connect(mapStateToProps, {})(RootRedirect);
